import { GetWaiverModel } from "@factory/model/query-model-waiver";
import "./print-waiver.scss";
import { appConfig } from "../../../app.config";

/* eslint-disable-next-line */
export interface PrintWaiverProps {
  waiver: GetWaiverModel;
  signature: string | null;
  isPreview?: boolean;
}

export function PrintWaiver({ waiver, signature, isPreview }: PrintWaiverProps) {
  const logo = `${
    appConfig.assetPath
  }/icon-192x192.png?${new Date().toISOString()}`;

  const formattedWaiver = waiver.description;
  const displayWaiverText = formattedWaiver ?? "";
  return (
    <div id="PrintWaiver" className={`print-waiver ${isPreview ? "text-[11px] leading-snug" : ""}`}>
      <style type="text/css" media="print">
        {
          "\
    @page { size: A4; }\
  "
        }
      </style>
      <div className={`${isPreview ? "p-1" : "p-4"} rounded-md page-break`}>
        <img
          src={logo}
          alt="Client Logo"
          className={isPreview ? "w-14 h-14 mx-auto mb-2" : "w-32 h-32 mx-auto mb-6 print:w-20 print:h-20"}
        />
        <div className="flex justify-center items-center">
          <p
            className={isPreview ? "text-gray-700 font-sans" : ""}
            dangerouslySetInnerHTML={{
              __html: displayWaiverText.replace(/\n/g, "<br/>"),
            }}
          ></p>
        </div>

        <section className={`flex justify-center items-center ${isPreview ? "mt-2" : "mt-6"}`}>
          <div className="flex flex-col items-center justify-center">
            {signature ? (
              <div className="flex justify-center">
                <img
                  src={signature}
                  alt={`signature`}
                  style={{
                    width: isPreview ? "80px" : "75%",
                    height: isPreview ? "40px" : "75%",
                  }}
                />
              </div>
            ) : null}
            <div className={`border-t border-t-gray-600 w-full text-center ${isPreview ? "text-[10px] px-4" : ""}`}>
              Signature
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PrintWaiver;
